module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_3.f12bbe6f.png";